// This file includes polyfills needed by Angular and is loaded before
// the app. You can add your own extra polyfills to this file.
(window as any).global = window;

// import 'form-data';

import 'zone.js';

